import React from 'react';
import { useApp } from '@/contexts/AppContext';
import CustomerQRCode from '@/components/CustomerQRCode';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Gift } from 'lucide-react';
import { useParams } from 'react-router-dom';

const CustomerView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { getCustomerById, getCustomerRewards } = useApp();
  
  // Safety check for id
  if (!id) {
    return (
      <div className="container mx-auto py-8 px-4">
        <h1 className="text-2xl font-bold text-center text-red-600">
          No customer ID provided
        </h1>
      </div>
    );
  }

  const customer = getCustomerById(id);
  const availableRewards = getCustomerRewards(id);

  if (!customer) {
    return (
      <div className="container mx-auto py-8 px-4">
        <h1 className="text-2xl font-bold text-center text-red-600">
          Customer not found
        </h1>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-8 px-4 max-w-screen-lg space-y-6">
      <h1 className="text-2xl md:text-3xl font-bold text-center text-restaurant-navy mb-8">
        Welcome{customer.name ? `, ${customer.name}` : ''}!
      </h1>

      <CustomerQRCode 
        customerId={customer.id} 
        customerName={customer.name}
      />

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Gift className="h-5 w-5 text-restaurant-navy" />
            Available Rewards
          </CardTitle>
        </CardHeader>
        <CardContent>
          {availableRewards.length === 0 ? (
            <p className="text-center text-muted-foreground py-4">
              No rewards available yet. Keep visiting to earn rewards!
            </p>
          ) : (
            <div className="space-y-4">
              {availableRewards.map(reward => (
                <div 
                  key={reward.id}
                  className="p-4 rounded-lg bg-restaurant-navy/5 border"
                >
                  <h3 className="font-semibold text-lg text-restaurant-navy">
                    {reward.name}
                  </h3>
                  <p className="text-muted-foreground mt-1">
                    {reward.description}
                  </p>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CustomerView; 